import TurfBuffer from '@turf/buffer';

import {polygon, featureCollection} from '@turf/helpers';

class LayerBoundary {
	

	
	constructor(du, scenario, tc) {
		
		this.scenario = scenario;
		this.map = du.map;
		this.du = du;
		this.tc = tc;
		//this.placeBoundaries();
		
	}
	
	
	
//	placeBoundaries(){
//		
//		var self = this;
//		var b = structuredClone(this.scenario.boundary);	
//		
//
//
//		if(this.map.getLayer(LayerBoundary.layerId)){
//			this.map.removeLayer(LayerBoundary.layerId);
//			this.map.removeSource(LayerBoundary.sourceId);
//		}
//
//				
//		if(!this.map.getSource(LayerBoundary.sourceId))
//			this.map.addSource(LayerBoundary.sourceId, {
//				'type': 'geojson',
//				'data': b.geometry
//			});
//
//		// Add a new layer to visualize the polygon.
//		if(!this.map.getLayer(LayerBoundary.layerId)){
//			this.map.addLayer({
//				'id': LayerBoundary.layerId,
//				'type': 'line',
//				'source': LayerBoundary.sourceId, // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['boundary'] ? 'visible' : 'none'
//				},
//				'paint': {
//					'line-color': LayerBoundary.defaultColor,
//					'line-opacity': 1,
//					'line-width' : LayerBoundary.defaultWidth
//				},
//				'filter': ['==', '$type', 'Polygon']
//			});
//
//		}
//	}
	json(){
		
		var self = this;
		var b = structuredClone(this.scenario.boundary);	
		


		const l = {
				source : {
					'id'	: LayerBoundary.sourceId,
					'type'	: 'geojson',
					'data'	: this.convert()
				}
			};

		l.layer = [{
			'id': LayerBoundary.layerId,
			'type': 'line',
			'source': LayerBoundary.sourceId, // reference the data source
			'paint': {
				'line-color': LayerBoundary.defaultColor,
				'line-width' : LayerBoundary.defaultWidth
			},
			'filter': ['==', '$type', 'Polygon']
		}];

		return l;
	}
	
	convert(){
		
		const polygons = [];
		const geom = this.scenario.boundary.geometry;

		if (geom.type === 'MultiPolygon') {
			geom.coordinates.forEach((polygonCoords, i) => {
				const polygonFeature = {
					'type': 'Feature',
					'geometry': {
					  'type': 'Polygon',
					  'coordinates': polygonCoords
					},
					'properties': { 
						'boundaryid':i
					},
					id:i
				};
				polygons.push(polygonFeature);
			});
		}

		return featureCollection(polygons);
	}
}

LayerBoundary.layerId			= 'boundary_layer';
LayerBoundary.sourceId			= 'boundary_source';
LayerBoundary.defaultWidth		= 6;
LayerBoundary.defaultColor		= "#ff0000";
LayerBoundary.layers			= [
	{id: LayerBoundary.layerId },
]


export default LayerBoundary;